/* eslint-disable  */

import {$typst, loadFonts} from '@myriaddreamin/typst.ts';

export let typstReady = false;

// :NOTE: Use fontsource (https://fontsource.org/ with jsdelivr CDN) for ttf fonts where possible (woff/woff2 fonts are not supported by typst... nor are variable fonts)
export const myFonts: string[] = [
  // FontAwesome
  'https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free@6.7.2/webfonts/fa-regular-400.ttf',
  'https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free@6.7.2/webfonts/fa-brands-400.ttf',
  'https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free@6.7.2/webfonts/fa-solid-900.ttf',
  'https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free@6.7.2/webfonts/fa-v4compatibility.ttf',

  // '/fonts/Font-Awesome-7-Brands-Regular-400.otf', // relative to the root of your webserver
  // '/fonts/Font-Awesome-7-Free-Regular-400.otf',
  // '/fonts/Font-Awesome-7-Free-Solid-900.otf',

  // JosefinSans
  'https://cdn.jsdelivr.net/fontsource/fonts/josefin-sans@latest/latin-100-italic.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/josefin-sans@latest/latin-200-italic.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/josefin-sans@latest/latin-300-italic.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/josefin-sans@latest/latin-400-italic.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/josefin-sans@latest/latin-500-italic.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/josefin-sans@latest/latin-600-italic.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/josefin-sans@latest/latin-700-italic.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/josefin-sans@latest/latin-100-normal.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/josefin-sans@latest/latin-200-normal.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/josefin-sans@latest/latin-300-normal.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/josefin-sans@latest/latin-400-normal.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/josefin-sans@latest/latin-500-normal.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/josefin-sans@latest/latin-600-normal.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/josefin-sans@latest/latin-700-normal.ttf',

  // :NOTE: variable fonts aren't supported by typst officially
  // '/fonts/JosefinSans-Italic-VariableFont_wght.ttf',
  // '/fonts/JosefinSans-VariableFont_wght.ttf',

  // Lato
  'https://cdn.jsdelivr.net/fontsource/fonts/lato@latest/latin-100-italic.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/lato@latest/latin-300-italic.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/lato@latest/latin-400-italic.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/lato@latest/latin-700-italic.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/lato@latest/latin-900-italic.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/lato@latest/latin-100-normal.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/lato@latest/latin-300-normal.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/lato@latest/latin-400-normal.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/lato@latest/latin-700-normal.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/lato@latest/latin-900-normal.ttf',

  // '/fonts/Lato-BlackItalic.ttf',
  // '/fonts/Lato-Black.ttf',
  // '/fonts/Lato-BoldItalic.ttf',
  // '/fonts/Lato-Bold.ttf',
  // '/fonts/Lato-Italic.ttf',
  // '/fonts/Lato-LightItalic.ttf',
  // '/fonts/Lato-Light.ttf',
  // '/fonts/Lato-Regular.ttf',
  // '/fonts/Lato-ThinItalic.ttf',
  // '/fonts/Lato-Thin.ttf',

  // Roboto
  'https://cdn.jsdelivr.net/fontsource/fonts/roboto@latest/latin-100-italic.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/roboto@latest/latin-300-italic.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/roboto@latest/latin-400-italic.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/roboto@latest/latin-700-italic.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/roboto@latest/latin-900-italic.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/roboto@latest/latin-100-normal.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/roboto@latest/latin-300-normal.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/roboto@latest/latin-400-normal.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/roboto@latest/latin-700-normal.ttf',
  'https://cdn.jsdelivr.net/fontsource/fonts/roboto@latest/latin-900-normal.ttf',
];

export const initTypst = async (): Promise<void> => {
  // Avoid double initialization
  if (typstReady) {
    return;
  }

  // SetCompilerInitOptions / setRendererInitOptions can throw if the compiler/renderer
  // has already been initialized by another caller. Call them defensively and ignore
  // the "already initialized" error while surfacing other failures.
  try {
    try {
      $typst.setCompilerInitOptions({
        getModule: () =>
          'https://cdn.jsdelivr.net/npm/@myriaddreamin/typst-ts-web-compiler@0.6.1-rc5/pkg/typst_ts_web_compiler_bg.wasm',
        beforeBuild: [loadFonts(myFonts)],
      });
    } catch (error: any) {
      const message = String(error?.message ?? error);
      if (
        message.includes('has been initialized') ||
        message.includes('already initialized')
      ) {
        // Benign, ignore

        console.warn('typst compiler already initialized, ignoring');
      } else {
        throw error;
      }
    }

    try {
      $typst.setRendererInitOptions({
        getModule: () =>
          'https://cdn.jsdelivr.net/npm/@myriaddreamin/typst-ts-renderer@0.6.1-rc5/pkg/typst_ts_renderer_bg.wasm',
      });
    } catch (error: any) {
      const message = String(error?.message ?? error);
      if (
        message.includes('has been initialized') ||
        message.includes('already initialized')
      ) {
        // Benign, ignore

        console.warn('typst renderer already initialized, ignoring');
      } else {
        throw error;
      }
    }
  } catch (error) {
    // If an unexpected error occurs during initialization, log and abort init.
    // initTypst callers should handle the fact initialization didn't occur.

    console.error('initTypst failed during set*Options:', error);
    return;
  }

  // :NOTE: You can add some extra source input files before compiling:
  // await $typst.addSource('/template.typ', templateContent);

  typstReady = true;
};
